import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconInvoice';
/** Renders an SVG icon. */
const SvgInvoice = ({ size, 'aria-hidden': ariaHidden, tone, UNSAFE_className, UNSAFE_style, ...rest }: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        d="M7.875 12.525A11 11 0 0 0 6 12.375c-.741 0-1.366.064-1.875.15V8a1.875 1.875 0 0 1 3.75 0zm6.125 7.6a1.125 1.125 0 0 0 0-2.25h-1a1.125 1.125 0 0 0 0 2.25zm7 0a1.125 1.125 0 0 0 0-2.25h-3a1.125 1.125 0 0 0 0 2.25zm-7 4a1.125 1.125 0 0 0 0-2.25h-1a1.125 1.125 0 0 0 0 2.25zm9 0a1.125 1.125 0 0 0 0-2.25h-5a1.125 1.125 0 0 0 0 2.25zM10.125 8c0-.675-.163-1.312-.451-1.875H24c1.035 0 1.875.84 1.875 1.875v18.44l-1.52-.507a1.13 1.13 0 0 0-.71 0L21 26.814l-2.645-.881a1.13 1.13 0 0 0-.71 0L15 26.814l-2.645-.881a1.13 1.13 0 0 0-.71 0l-1.52.506zm18 0A4.125 4.125 0 0 0 24 3.875H6A4.125 4.125 0 0 0 1.875 8v6l.01.145a1.125 1.125 0 0 0 1.616.862H3.5l-.003.002.085-.033c.086-.033.234-.083.44-.134.414-.104 1.073-.217 1.978-.217.834 0 1.458.098 1.875.194V28a1.126 1.126 0 0 0 1.48 1.067L12 28.186l2.645.881.175.043c.179.03.362.015.535-.043L18 28.186l2.645.881.175.043c.179.03.362.015.535-.043L24 28.186l2.645.881A1.126 1.126 0 0 0 28.125 28z"
      />
      <path
        fill="currentColor"
        d="M17 8v.132c-1.187.323-1.985 1.22-1.985 2.368 0 1.448 1.268 2.5 2.985 2.5.473 0 .725.132.84.23.116.098.145.198.145.27s-.03.172-.144.27c-.116.098-.368.23-.841.23-.463 0-1.102-.077-1.803-.219a1 1 0 1 0-.394 1.961c.402.081.809.147 1.197.193V16a1 1 0 1 0 2 0v-.13c1.187-.324 1.985-1.221 1.985-2.37 0-1.448-1.268-2.5-2.985-2.5-.473 0-.725-.132-.84-.23-.116-.098-.145-.198-.145-.27s.03-.172.144-.27c.116-.098.368-.23.841-.23.463 0 1.102.077 1.803.219a1 1 0 1 0 .394-1.961A15 15 0 0 0 19 8.066V8a1 1 0 1 0-2 0"
      />
    </svg>
  );
};
SvgInvoice.displayName = displayName;
export default SvgInvoice;
